/**
 * 安全混入 - 自动为所有输入框添加XSS防护
 * 全局混入，无需在每个组件中单独引入
 */

import { detectXSS, escapeHtml } from '@/utils/security';

export default {
  mounted() {
    // 在组件挂载后，为所有输入框添加XSS防护
    this.$nextTick(() => {
      this.addXSSProtection();
    });
  },
  
  methods: {
    /**
     * 为当前组件的所有输入框添加XSS防护
     */
    addXSSProtection() {
      // 检查$el是否存在且为DOM元素
      if (!this.$el || typeof this.$el.querySelectorAll !== 'function') {
        return;
      }
      
      // 获取所有input和textarea元素
      const inputs = this.$el.querySelectorAll('input, textarea');
      
      inputs.forEach(input => {
        // 跳过特殊类型的输入框
        const type = input.getAttribute('type');
        if (['password', 'file', 'checkbox', 'radio', 'hidden'].includes(type)) {
          return;
        }
        
        // 检查是否已经添加过防护
        if (input.dataset.xssProtected === 'true') {
          return;
        }
        
        // 标记已保护
        input.dataset.xssProtected = 'true';
        
        // 添加输入事件监听
        input.addEventListener('input', this.handleXSSCheck.bind(this, input));
        
        // 添加失焦事件监听（转义HTML）
        input.addEventListener('blur', this.handleEscapeHTML.bind(this, input));
      });
    },
    
    /**
     * 检测XSS攻击
     */
    handleXSSCheck(input, event) {
      const value = input.value;
      
      // 检测危险脚本
      if (detectXSS(value)) {
        // 清空输入
        input.value = '';
        
        // 不再显示警告通知（用户体验优化）
        // if (this.$notify) {
        //   this.$notify({
        //     title: '⚠️ 安全警告',
        //     message: '检测到潜在的XSS攻击代码，输入已被清空',
        //     type: 'warning',
        //     duration: 3000
        //   });
        // }
        
        // 触发Vue的input事件
        input.dispatchEvent(new Event('input', { bubbles: true }));
        
        // 仅记录安全日志
        console.warn('[XSS防护] 检测到危险输入:', value);
      }
    },
    
    /**
     * 转义HTML特殊字符（失焦时）
     */
    handleEscapeHTML(input, event) {
      // 只对文本类型的input和textarea进行转义
      const type = input.getAttribute('type');
      if (!type || type === 'text' || input.tagName === 'TEXTAREA') {
        const value = input.value;
        if (value) {
          const escaped = escapeHtml(value);
          if (escaped !== value) {
            input.value = escaped;
            // 触发Vue的input事件
            input.dispatchEvent(new Event('input', { bubbles: true }));
          }
        }
      }
    }
  }
};




// WEBPACK FOOTER //
// ./src/mixins/securityMixin.js